var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9717 8.29297L17.7217 5.54297L14.9717 4.29297L17.7217 3.04297L18.9717 0.292969L20.2217 3.04297L22.9717 4.29297L20.2217 5.54297L18.9717 8.29297ZM18.9717 22.293L17.7217 19.543L14.9717 18.293L17.7217 17.043L18.9717 14.293L20.2217 17.043L22.9717 18.293L20.2217 19.543L18.9717 22.293ZM8.97168 19.293L6.47168 13.793L0.97168 11.293L6.47168 8.79297L8.97168 3.29297L11.4717 8.79297L16.9717 11.293L11.4717 13.793L8.97168 19.293Z",
    fill: "white"
  })));
};
export default SvgStars;